/**
 * ANQ.Rate.API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { CreateRateDetail } from '../model/createRateDetail';
import { CreateRateDetailDto } from '../model/createRateDetailDto';
import { RateDetail } from '../model/rateDetail';
import { ValidateRateDetailDto } from '../model/validateRateDetailDto';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class RateDetailsService {

    protected basePath = '/';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     *
     *
     * @param body
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiRateDetailsCreateHubRateDetailPost(body?: CreateRateDetailDto, observe?: 'body', reportProgress?: boolean): Observable<string>;
    public apiRateDetailsCreateHubRateDetailPost(body?: CreateRateDetailDto, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<string>>;
    public apiRateDetailsCreateHubRateDetailPost(body?: CreateRateDetailDto, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<string>>;
    public apiRateDetailsCreateHubRateDetailPost(body?: CreateRateDetailDto, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<string>('post',`${this.basePath}/api/RateDetails/CreateHubRateDetail`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     *
     *
     * @param body
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiRateDetailsCreateRateDetailByListPost(body?: Array<CreateRateDetail>, observe?: 'body', reportProgress?: boolean): Observable<string>;
    public apiRateDetailsCreateRateDetailByListPost(body?: Array<CreateRateDetail>, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<string>>;
    public apiRateDetailsCreateRateDetailByListPost(body?: Array<CreateRateDetail>, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<string>>;
    public apiRateDetailsCreateRateDetailByListPost(body?: Array<CreateRateDetail>, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<string>('post',`${this.basePath}/api/RateDetails/CreateRateDetailByList`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     *
     *
     * @param rateDetailId
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */

    public apiRateDetailsDeleteDelete(rateDetailId?: string, observe?: 'body', reportProgress?: boolean): Observable<string>;
    public apiRateDetailsDeleteDelete(rateDetailId?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<string>>;
    public apiRateDetailsDeleteDelete(rateDetailId?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<string>>;
    public apiRateDetailsDeleteDelete(rateDetailId?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (rateDetailId !== undefined && rateDetailId !== null) {
            queryParameters = queryParameters.set('rateDetailId', <any>rateDetailId);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<any>('delete',`${this.basePath}/api/RateDetails/Delete`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     *
     *
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiRateDetailsGetAllRateDetailsGet(observe?: 'body', reportProgress?: boolean): Observable<Array<RateDetail>>;
    public apiRateDetailsGetAllRateDetailsGet(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<RateDetail>>>;
    public apiRateDetailsGetAllRateDetailsGet(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<RateDetail>>>;
    public apiRateDetailsGetAllRateDetailsGet(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<RateDetail>>('get',`${this.basePath}/api/RateDetails/GetAllRateDetails`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     *
     *
     * @param id
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiRateDetailsGetRateDetailsByIdGet(id?: string, observe?: 'body', reportProgress?: boolean): Observable<string>;
    public apiRateDetailsGetRateDetailsByIdGet(id?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<string>>;
    public apiRateDetailsGetRateDetailsByIdGet(id?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<string>>;
    public apiRateDetailsGetRateDetailsByIdGet(id?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (id !== undefined && id !== null) {
            queryParameters = queryParameters.set('id', <any>id);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<string>('get',`${this.basePath}/api/RateDetails/GetRateDetailsById`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     *
     *
     * @param id
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiRateDetailsGetRateDetailsByRateIdGet(id?: string, observe?: 'body', reportProgress?: boolean): Observable<Array<RateDetail>>;
    public apiRateDetailsGetRateDetailsByRateIdGet(id?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<RateDetail>>>;
    public apiRateDetailsGetRateDetailsByRateIdGet(id?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<RateDetail>>>;
    public apiRateDetailsGetRateDetailsByRateIdGet(id?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (id !== undefined && id !== null) {
            queryParameters = queryParameters.set('id', <any>id);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<RateDetail>>('get',`${this.basePath}/api/RateDetails/GetRateDetailsByRateId`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     *
     *
     * @param body
     * @param rateId
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiRateDetailsUpdateByListPut(body?: Array<RateDetail>, rateId?: string, observe?: 'body', reportProgress?: boolean): Observable<string>;
    public apiRateDetailsUpdateByListPut(body?: Array<RateDetail>, rateId?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<string>>;
    public apiRateDetailsUpdateByListPut(body?: Array<RateDetail>, rateId?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<string>>;
    public apiRateDetailsUpdateByListPut(body?: Array<RateDetail>, rateId?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {



        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (rateId !== undefined && rateId !== null) {
            queryParameters = queryParameters.set('rateId', <any>rateId);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<string>('put',`${this.basePath}/api/RateDetails/UpdateByList`,
            {
                body: body,
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     *
     *
     * @param body
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiRateDetailsValidateRateDetailPost(body?: ValidateRateDetailDto, observe?: 'body', reportProgress?: boolean): Observable<string>;
    public apiRateDetailsValidateRateDetailPost(body?: ValidateRateDetailDto, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<string>>;
    public apiRateDetailsValidateRateDetailPost(body?: ValidateRateDetailDto, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<string>>;
    public apiRateDetailsValidateRateDetailPost(body?: ValidateRateDetailDto, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<string>('post',`${this.basePath}/api/RateDetails/ValidateRateDetail`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
